import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'Martín',
    age: '27',
    role: 'DJ',
    location: 'Buenos Aires',
    quote: 'Pincho todos los findes y QUID me cambió la vida. Escucho cada detalle del set y al otro día estoy joya. No salgo sin ellos.'
  }, {
    name: 'Lucía',
    age: '24',
    role: 'Productora',
    location: 'Córdoba',
    quote: 'Antes terminaba cada fiesta con los oídos destruidos. Con QUID puedo estar hasta el final sin drama. Son un antes y después.'
  }, {
    name: 'Franco',
    age: '29',
    role: 'Bartender',
    location: 'Rosario',
    quote: 'Laburo en boliche hace años. QUID me salvó los oídos posta. Ahora aguanto toda la noche sin que me explote la cabeza.'
  }];
  return <section className="bg-white py-24" data-id="element-155">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-156">
        <h2 className="mb-16 text-center text-3xl font-bold text-gray-900 sm:text-4xl" data-id="element-157">
          Lo que dicen los que ya se cuidan
        </h2>

        <div className="grid gap-8 md:grid-cols-3" data-id="element-158">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1,
          duration: 0.5
        }} className="flex flex-col rounded-2xl bg-gray-50 p-8 shadow-sm" data-id="element-159">
              <div className="mb-4 flex text-[#FF6B35]" data-id="element-160">
                {[...Array(5)].map((_, i) => <Star key={i} className="h-5 w-5 fill-current" data-id="element-161" />)}
              </div>
              <p className="mb-6 flex-1 text-lg italic text-gray-700" data-id="element-162">
                "{t.quote}"
              </p>
              <div className="mt-auto border-t border-gray-200 pt-4" data-id="element-163">
                <p className="font-bold text-gray-900" data-id="element-164">
                  {t.name}, {t.age}
                </p>
                <p className="text-sm text-gray-500" data-id="element-165">
                  {t.role} - {t.location}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}